import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent { }



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-footer/app-footer.component.ts